module.exports = __webpack_public_path__ + "static/img/js.6393710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/js.png
// module id = v5lu
// module chunks = 1